export default "__VITE_ASSET__DZMvRhOR__"